<template>
  <div>
    <div class="clearfix"></div>
    <div class="banner" @click="handleCloseMenu">
      <mainMenu ref="mainMenu"></mainMenu>
      <!--BANNER	-->
      <div class="swiper-container banner-container" ref="bannerSwiper">
        <div class="swiper-wrapper">
          <!-- <div class="swiper-slide banner-item">
            <div class="page-number">01</div>
            <div class="page-words">Nynör pron utan nedir.<br> Kroser,Bjudkaffe hynar paratårad. Eupp. Jäde bes. </div>
            <video :src="require('@/assets/xh/images/-7ca6-452b-ac44-30540d1f41a9.mp4')" autoplay="autoplay" muted="muted" loop="loop" ></video>
          </div>
          <div class="swiper-slide banner-item">
            <div class="page-number">02</div>
            <div class="page-words">Kroser dona det Nynör pron utan nedir,<br> Ajiqwekaffe hynar paratårad. Eupp. Jädeas zsm iiwbes.  </div>
            <img :src="require('@/assets/xh/images/image 2.png')" alt="" >
          </div>
          <div class="swiper-slide banner-item">
            <div class="page-number">03</div>
            <div class="page-words">Kroser dona det Nynör pron utan nedir,<br> Ajiqwekaffe hynar paratårad. Eupp. Jädeas zsm iiwbes. </div>
            <img :src="require('@/assets/xh/images/image 3.png')" alt="" >
          </div> -->
          <div class="swiper-slide banner-item" v-for="(item,index) in bannerList">
            <div class="page-number">{{ item.label }}</div>
            <div class="page-words" v-html="item.desc"></div>
            <video v-if="item.type == 1" :src="item.src" autoplay="true" muted="muted" loop="loop"></video>
            <img v-if="item.type == 0"  :src="item.src" alt="" style="width:100%">
          </div>
        </div>

        <div class="swiper-button-prev banner-prev icons"></div>
        <div class="swiper-button-next banner-next icons" ></div>
      </div>

    </div>

    <!-- brand bar -->
    <div class="brand-bar f_spec_sc-R">
      ViaWatch &#8226; ViaWatch &#8226; ViaWatch &#8226; ViaWatch &#8226; ViaWatch &#8226; ViaWatch &#8226; ViaWatch &#8226; ViaWatch &#8226; ViaWatch &#8226; ViaWatch &#8226; ViaWatch &#8226; ViaWatch &#8226; ViaWatch &#8226; ViaWatch &#8226; ViaWatch
    </div>

    <!-- benefits -->
    <div class="swiper-container benefits-carousel" ref="benefitSwiper">
        <div class="swiper-wrapper">
           <div class="swiper-slide" >
        <div class="l-box row">
          <div class="col-md-6"><img :src="require('@/assets/xh/images/img2.png')" alt="" class="img-responsive"></div>
          <div class="col-md-6 box-words">
            <h2 class="f_spec_sc-B">The Best Market</h2>
            <p>Lörem ipsum plamis heterotodade pas. Spebel fängen. Infraskapet ben. Mast blorange geotaggning. Tesk triren i luk nimisk. </p>
            <a href="#" class="f_kelly-R">Learn More</a>
          </div>
       </div>
       </div>
            <div class="swiper-slide">
        <div class="l-box row">
          <div class="col-md-6 box-words">
            <h2 class="f_spec_sc-B">Trusty Auction Platform</h2>
            <p>Lörem ipsum plamis heterotodade pas. Spebel fängen. Infraskapet ben. Mast blorange geotaggning. Tesk triren i luk nimisk. </p>
            <a href="#" class="f_kelly-R">Learn More</a>
          </div>
          <div class="col-md-6"><img :src="require('@/assets/xh/images/img1.png')" alt="" class="img-responsive"></div>
          </div>
      </div>
        </div>
        <!-- Add Arrows -->
        <div class="swiper-button-next benefits-next"></div>
        <div class="swiper-button-prev benefits-prev"></div>
    </div>

    <!-- home product -->
    <div class="home-prd">
      <div class="container">
        <ul role="tablist" class="prd-nav">
          <li role="presentation" class="prd-tab" :class="[homePrdTab == 'bestSale' ? 'active' : '']" @click="handleHomePrdTab('bestSale')">
            <a href="javascript:;" id="home-tab" role="tab" data-toggle="tab" >BEST SALE</a>
          </li>
          <li role="presentation" class="prd-tab" :class="[homePrdTab == 'newArrival' ? 'active' : '']" @click="handleHomePrdTab('newArrival')">
            <a href="javascript:;" role="tab" id="profile-tab" data-toggle="tab" >NEW ARRIVAL</a>
          </li>
        </ul>
        <div class="clearfix"></div>
        <div class="tab-content">
          <div role="tabpanel" class="tab-pane fade" id="bestSale" :class="[homePrdTab == 'bestSale' ? 'active in' : '']">
          <ul class="prd-list">
            <div class="more-links f_kelly-R"> <router-link :to="{path: 'watchlist',query:{goodsType: 'bestSale'}}"> View All</router-link></div>
            <li class="prd-item" v-for="(item,index) in bestSaleList">
              <a @click="tiao(item.goodsId)"><div class="prd-img"><img :src="item.picUrl" class="img-responsive" alt="" style="width: 300px;"></div>
                <b class="prd-brand">{{ item.brandName }}</b>
                <p class="prd-name">{{ item.goodsName }}</p>
                <span class="prd-price">$ {{item.originalPrice }}</span>
                <span v-if="item.webPrice && item.originalPrice != item.webPrice">{{ item.webPrice }}</span>
              </a>
            </li>

          </ul>
          </div>
          <div role="tabpanel" class="tab-pane fade" id="newArrival" :class="[homePrdTab == 'newArrival' ? 'active in' : '']">
          <ul class="prd-list">
            <div class="more-links f_kelly-R"> <router-link :to="{path: 'watchlist',query:{goodsType: 'newArrival'}}"> View All</router-link></div>
              <li class="prd-item" v-for="(item,index) in newArrivalList" :key="index">
              <a @click="tiao(item.goodsId)"><div class="prd-img"><img :src="item.picUrl" class="img-responsive" alt="" style="width: 300px;"></div>
                <b class="prd-brand">{{ item.brandName }}</b>
                <p class="prd-name">{{ item.goodsName }}</p>
                <span class="prd-price">$ {{ item.originalPrice }}</span>
                <span v-if="item.webPrice && item.originalPrice != item.webPrice">{{ item.webPrice }}</span>
              </a>
            </li>

          </ul>
          </div>
        </div>
      </div>
    </div>

    <!--  Search by type	-->
    <div class="home-type">
    	<div class="container">
        <h1 class="f_spec_sc-R">Search by type</h1>
    	</div>

    	<!-- Swiper 2 -->
      <div class="swiper-container type-list" ref="searchTypeSwiper">
        <ul class="swiper-wrapper">
          <li class="swiper-slide type-item" v-for="(item, index) in searchList">
            <a href="javascript:;">
              <img :src="item.src" alt="">
              <span v-if="item.isBr" v-html="item.nameFmt"></span>
              <span v-if="!item.isBr"> {{ item.name }} </span>
            </a>
          </li>

        </ul>
        <div class="swiper-scrollbar"></div>
      </div>
    </div>

    <!--Warranties	-->
    <div class="warranties">
    		<h1 class="title f_spec_sc-R"> <div class="container">Warranties</div></h1>
    	<div class="container">
    	<ul class="content row">
    		<li class="col-md-4">
    			<div class="item">
    			<img :src="require('@/assets/xh/images/warranties-icon.png')" alt="">
    			<h3 class="f_spec-B">Authenticity Guarantee</h3>
    			<p>Lörem ipsum plamis heterotodade pas. Spebel fängen. Infraskapet ben. Mast blorange geotaggning. Tesk triren i luk nimisk. </p>
    			</div>
    		</li>
    		<li class="col-md-4">
    			<div class="item">
    			<img :src="require('@/assets/xh/images/warranties-icon.png')" alt="">
    			<h3 class="f_spec-B">Authenticity Guarantee</h3>
    			<p>Lörem ipsum plamis heterotodade pas. Spebel fängen. Infraskapet ben. Mast blorange geotaggning. Tesk triren i luk nimisk. </p>
    			</div>
    		</li>
    		<li class="col-md-4">
    			<div class="item">
    			<img :src="require('@/assets/xh/images/warranties-icon.png')" alt="">
    			<h3 class="f_spec-B">Authenticity Guarantee</h3>
    			<p>Lörem ipsum plamis heterotodade pas. Spebel fängen. Infraskapet ben. Mast blorange geotaggning. Tesk triren i luk nimisk. </p>
    			</div>
    		</li>
    	</ul>
    	</div>
    </div>

  </div>
</template>

<script>
import MainMenu from "@/components/MainMenu";
import Swiper, { Navigation, Pagination } from 'swiper'
import {goodsList,dashboard,selectListByType,selectBanner} from '@/api/index'

export default {
	name: "IndexView",
	components: {
    MainMenu
	},
  data() {
    return {
      homePrdTab: 'bestSale',
      bannerList: [],
      bestSaleList: [],
      newArrivalList: [],
      searchList: [],
      goodsType:"bestSale",
    };
  },
  created() {
    this.bannerList = [
      {id:1, src:require('@/assets/xh/images/-7ca6-452b-ac44-30540d1f41a9.mp4'), label:'01', type:1,
       desc:'Nynör pron utan nedir.<br> Kroser,Bjudkaffe hynar paratårad. Eupp. Jäde bes.'},
      {id:2, src:require('@/assets/xh/images/image 2.png'), label:'02', type:0,
       desc:'Kroser dona det Nynör pron utan nedir,<br> Ajiqwekaffe hynar paratårad. Eupp. Jädeas zsm iiwbes.'},
      {id:3, src:require('@/assets/xh/images/image 3.png'), label:'03', type:0,
       desc:'Kroser dona det Nynör pron utan nedir,<br> Ajiqwekaffe hynar paratårad. Eupp. Jädeas zsm iiwbes.'},
    ];
    this.bestSaleList = [
      {id:1, picUrl:require('@/assets/xh/images/homeprd1.png'), brandName:'Omega', goodsName:'Constellation', originalPrice:'180,000'},
      {id:2, picUrl:require('@/assets/xh/images/homeprd2.png'), brandName:'Omega', goodsName:'Constellation', originalPrice:'180,000'},
      {id:3, picUrl:require('@/assets/xh/images/homeprd3.png'), brandName:'Omega', goodsName:'Constellation', originalPrice:'180,000'},
      {id:4, picUrl:require('@/assets/xh/images/homeprd2.png'), brandName:'Omega', goodsName:'Constellation', originalPrice:'180,000'},
      {id:5, picUrl:require('@/assets/xh/images/homeprd3.png'), brandName:'Omega', goodsName:'Constellation', originalPrice:'180,000'},
      {id:6, picUrl:require('@/assets/xh/images/homeprd1.png'), brandName:'Omega', goodsName:'Constellation', originalPrice:'180,000'},
      {id:7, picUrl:require('@/assets/xh/images/homeprd2.png'), brandName:'Omega', goodsName:'Constellation', originalPrice:'180,000'},
      {id:8, picUrl:require('@/assets/xh/images/homeprd3.png'), brandName:'Omega', goodsName:'Constellation', originalPrice:'180,000'},
      {id:9, picUrl:require('@/assets/xh/images/homeprd2.png'), brandName:'Omega', goodsName:'Constellation', originalPrice:'180,000'},
      {id:10,picUrl:require('@/assets/xh/images/homeprd3.png'), brandName:'Omega', goodsName:'Constellation', originalPrice:'180,000'},
    ]
    this.newArrivalList = [
      {id:1, picUrl:require('@/assets/xh/images/homeprd3.png'), brandName:'Omega', goodsName:'Constellation', originalPrice:'180,000'},
      {id:2, picUrl:require('@/assets/xh/images/homeprd2.png'), brandName:'Omega', goodsName:'Constellation', originalPrice:'180,000'},
      {id:3, picUrl:require('@/assets/xh/images/homeprd1.png'), brandName:'Omega', goodsName:'Constellation', originalPrice:'180,000'},
      {id:4, picUrl:require('@/assets/xh/images/homeprd2.png'), brandName:'Omega', goodsName:'Constellation', originalPrice:'180,000'},
      {id:5, picUrl:require('@/assets/xh/images/homeprd1.png'), brandName:'Omega', goodsName:'Constellation', originalPrice:'180,000'},
      {id:6, picUrl:require('@/assets/xh/images/homeprd3.png'), brandName:'Omega', goodsName:'Constellation', originalPrice:'180,000'},
      {id:7, picUrl:require('@/assets/xh/images/homeprd2.png'), brandName:'Omega', goodsName:'Constellation', originalPrice:'180,000'},
      {id:8, picUrl:require('@/assets/xh/images/homeprd1.png'), brandName:'Omega', goodsName:'Constellation', originalPrice:'180,000'},
      {id:9, picUrl:require('@/assets/xh/images/homeprd2.png'), brandName:'Omega', goodsName:'Constellation', originalPrice:'180,000'},
      {id:10,picUrl:require('@/assets/xh/images/homeprd1.png'), brandName:'Omega', goodsName:'Constellation', originalPrice:'180,000'},
    ]
    this.searchList = [
      {id:1, src:require('@/assets/xh/images/typebg1.png'), name: 'Men’s Watch'},
      {id:2, src:require('@/assets/xh/images/typebg2.png'), name: 'Rolex'},
      {id:3, src:require('@/assets/xh/images/typebg3.png'), name: 'F.P. JOURNE'},
      {id:4, src:require('@/assets/xh/images/typebg1.png'), name: 'GLASHÜTTE ORIGINAL', isBr: true, nameFmt: 'GLASHÜTTE <br>ORIGINAL'},
      {id:5, src:require('@/assets/xh/images/typebg2.png'), name: 'Rolex'},
      {id:6, src:require('@/assets/xh/images/typebg3.png'), name: 'F.P. JOURNE'},
      {id:7, src:require('@/assets/xh/images/typebg1.png'), name: 'Men’s Watch'},
      {id:8, src:require('@/assets/xh/images/typebg2.png'), name: 'Men’s Watch'},
      {id:9, src:require('@/assets/xh/images/typebg3.png'), name: 'Men’s Watch'},
      {id:10,src:require('@/assets/xh/images/typebg1.png'), name: 'Men’s Watch'},
    ]
    // this.selectGoods()
    this.selectListByType()
    this.selectBannerList()


  },
  mounted() {
    new Swiper(this.$refs.bannerSwiper, {
      // configure Swiper to use modules
      modules: [Navigation, Pagination],
      // Optional parameters
      // loop: true,
      direction: 'vertical',
      mousewheel: true,

      // If we need pagination
      direction: 'vertical', // 垂直切换选项
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.banner-next',
        prevEl: '.banner-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    })

    new Swiper(this.$refs.benefitSwiper, {
      // configure Swiper to use modules
      modules: [Navigation, Pagination],
      // Optional parameters
      // loop: true,

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.benefits-next',
        prevEl: '.benefits-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    })

    new Swiper(this.$refs.searchTypeSwiper, {
      // configure Swiper to use modules
      modules: [Navigation, Pagination],
      // Optional parameters
      // loop: true,
      slidesPerView: 'auto',
      spaceBetween: 30,
      freeMode: true,
      // direction: "horizontal",
      // followFinger: true,
      mousewheel: true,
      // If we need pagination
      // pagination: {
      //   el: '.swiper-pagination',
      // },

      // Navigation arrows
      // navigation: {
      //   nextEl: '.benefits-next',
      //   prevEl: '.benefits-prev',
      // },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    })
  },
  methods: {

    // viewAll(){
    //   this.$router.push({
    //     path: 'watchlist',
    //     query: {
    //       goodsType: this.goodsType,
    //     }
    //   })
    // },
    tiao(id){
     this.$router.push({ path: 'watchpage', query: { id: id }}, () => {})
    },

    handleCloseMenu(event) {
      var sp = document.getElementById("headMenu")
      if (!sp.contains(event.target)) {
      	this.$refs.mainMenu.searchFocus = false;
      	this.$refs.mainMenu.isHovered = false;
      }
    },
    handleHomePrdTab(tab) {
      if (tab == 'newArrival') {
        this.homePrdTab = 'newArrival';
        this.goodsType = 'newArrival'
        selectListByType({goodsType:this.homePrdTab,isShow: 1}).then(response=>{
          this.newArrivalList=response.data.data.list
        })
      } else {
        this.homePrdTab = 'bestSale';
        this.goodsType = 'bestSale'
        console.log(this.goodsType)
      }
    },
    selectGoods(){
      goodsList().then(response => {
        console.log('===')
        console.log(response.data.data)
      })
    },
    selectListByType(){
      var that=this
      selectListByType({goodsType:that.homePrdTab,isShow: 1}).then(response=>{
        console.log(response.data.data)
        that.bestSaleList=response.data.data.list
      })

    },
    selectBannerList(){
      selectBanner({position:1}).then(response=>{
        console.log('===banner')
        console.log(response.data.data)
      })
    }
  }
}
</script>

<style scoped>
  @import url("../assets/xh/css/bootstrap.min.css");
  @import url("../assets/xh/css/reset.css");
  @import url("../assets/xh/css/home.css");
  @import url("../assets/xh/css/fonts.css");
  /* .swiper-horizontal > .swiper-scrollbar {
    position: absolute;
    left: 1%;
    bottom: 3px;
    z-index: 50;
    height: 5px;
    width: 98%;
  } */
 .swiper-slide {
    height: auto;
  }
  .banner-item img, .banner-item video {
    height: 100%;
    object-fit: fill;
  }

</style>



// WEBPACK FOOTER //
// src/views/IndexView.vue